import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import i18n from '@/i18n/i18n'
import UserLoginRegExpSetupView from '@/components/TriggerSetup/conditions/UserLoginRegExp/UserLoginRegExpSetupView.vue'

const condition: () => EntityData = () => {
  return {
    'setupView': UserLoginRegExpSetupView,
    'structure': {
      'type': 'UserLoginRegExp',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('UserLoginRegExp') }`,
    'limited': getTagsByFieldKey('UserLoginRegExpCondition'),
    'helpMessage': i18n.t('regexp_condition_help_message').toString()
  }
}

export default condition
